module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel),
      expression: "panel"
    }],
    staticClass: "container"
  }, [_c('div', [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.url,
      "alt": "Picture"
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "id": "button"
    },
    on: {
      "click": _vm.crop
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "id": "button2"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "show"
  }, [_c('div', {
    staticClass: "picture",
    style: ('backgroundImage:url(' + (_vm.headerImage ? _vm.headerImage : _vm.userInfo.headimgurl) + ')')
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "change"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    ref: "ipt",
    attrs: {
      "type": "file",
      "id": "change",
      "name": "image",
      "accept": "image"
    },
    on: {
      "change": _vm.change
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4799f6a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/HeadPicFile/HeadPicFile.vue
// module id = 617
// module chunks = 0